import { Dropdown } from 'antd-mobile'
import React, { useState } from 'react'
import { MenuProps } from 'antd'
import { MenuOutlined, CloseCircleOutlined } from '@ant-design/icons'
import { MenuList } from 'components/common'

export const HamburgerMenu: React.FC = () => {
  const [collapsed, setCollapsed] = useState(false)
  const toggleCollapsed = () => {
    setCollapsed(!collapsed)
  }

  return (
    <div className="hamburger-menu">
      <Dropdown
        arrow={
          collapsed ? (
            <CloseCircleOutlined className="menu-icon" />
          ) : (
            <MenuOutlined className="menu-icon" />
          )
        }
        onChange={toggleCollapsed}
      >
        <Dropdown.Item key="sorter" title={<></>}>
          <MenuList></MenuList>
        </Dropdown.Item>
      </Dropdown>
    </div>
  )
}

export default HamburgerMenu
